
    export const PAWUKON_LIST = [];
    export const pawukonDatabase = {};
    export const MASTER_PAWUKON = [];
    export const getPawukonData = () => null;
    export const getPawukonDetail = () => null;
  